var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTravel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-travel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.387,
    height: 52.387,
    viewBox: "0 0 52.387 52.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39716",
    "data-name": "Path 39716",
    d: "M26.193,0A26.193,26.193,0,1,1,0,26.193,26.193,26.193,0,0,1,26.193,0Z",
    fillOpacity: 0.15,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39721",
    "data-name": "Path 39721",
    d: "M28.025,20.218v-2.6L16.965,11.109V3.952a1.952,1.952,0,0,0-3.9,0v7.157L2,17.615v2.6l11.061-3.253v7.157L9.808,26.073v1.952l5.205-1.3,5.205,1.3V26.073l-3.253-1.952V16.965Z",
    transform: "translate(11.686 11.685)",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39719",
    "data-name": "Path 39719",
    d: "M0,0H31.23V31.23H0Z",
    transform: "translate(11.082 11.082)",
    fill: "none",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTravel);
export default __webpack_public_path__ + "static/media/ic-travel.119b52133bb1e66b8a1989f8411871ef.svg";
export { ForwardRef as ReactComponent };